import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DesignState {
    theme: "light" | "dark" | "system";
    sidebarState: "expanded" | "collapsed";
}
const initialState: DesignState = {
    theme: "light",
    sidebarState: "expanded",
};

export const designSlice = createSlice({
    name: "design",
    initialState,
    reducers: {
        setTheme: (state, action: PayloadAction<"light" | "dark" | "system">) => {
            state.theme = action.payload;
        },
        setSidebarState: (state, action: PayloadAction<"expanded" | "collapsed">) => {
            state.sidebarState = action.payload;
        },
    },
});
